<template>
  <div>
    <div class="intro">
      <h1>Bubble Pop!</h1>
      <button ref="startBtn" class="start" @click="start">
        Start
      </button>
    </div>
    <div class="progress"></div>
    <div class="levels">
      <h1></h1>
    </div>
    <div id="canvas-wrapper">
      <canvas ref="myCanvas" id="canvas" width="800" height="400">
        Sorry, your browser doesn't support Canvas.
      </canvas>
    </div>
  </div>
</template>

<script>
const cards = [
  {
    name: "1",
    img: "1.png",
    isFlipped: false,
    isMatched: false,
    title: "1"
  },
  {
    name: "2",
    img: "2.png",
    isFlipped: false,
    isMatched: false,
    title: "2"
  },
  {
    name: "3",
    img: "3.png",
    isFlipped: false,
    isMatched: false,
    title: "3"
  }
];

import _ from "lodash";
import Vue from "vue";
import MemoryCard from "./card";
import { mapGetters } from "vuex";
export default {
  name: "Display_BubblePop",
  components: {
    MemoryCard
  },
  props: {
    resource: {
      type: Object,
      default: () => {}
    }
  },
  created() {},
  mounted() {
    console.log(`Refs are ${this.$refs}`);
    this.canvas = this.$refs.myCanvas;
    this.init();
  },
  computed: {},
  methods: {
    init() {
      this.size(); // set initial size
      this.loadSounds();
      this.bubbleMultiplier(); // make initial bubbles on load
      this.animate(); // move bubbles around screen
      this.bind(); // bind event handlers
    },
    size() {
      this.canvas.width = window.innerWidth;
      this.canvas.height = window.innerHeight;
    },
    loadSounds() {
      //sound type
      const sounds = {
        high: new Audio(
          "http://ryanwells.com/bubble-pop/dist/audio/bubble-pop-high.mp3"
        ),
        med: new Audio(
          "http://ryanwells.com/bubble-pop/dist/audio/bubble-pop-med.mp3"
        ),
        low: new Audio(
          "http://ryanwells.com/bubble-pop/dist/audio/bubble-pop-low.mp3"
        )
      };
      // set volume for each sound
      Object.values(sounds).forEach(sound => {
        sound.volume = 0.25;
      });
      return sounds;
    },
    fadeIn(elem, ms) {
      if (!elem) return;

      elem.style.opacity = 0;
      elem.style.filter = "alpha(opacity=0)";
      elem.style.display = "inline-block";
      elem.style.visibility = "visible";

      if (ms) {
        let opacity = 0;
        const timer = setInterval(function() {
          opacity += 50 / ms;
          if (opacity >= 1) {
            clearInterval(timer);
            opacity = 1;
          }
          elem.style.opacity = opacity;
          elem.style.filter = `alpha(opacity=${opacity * 100})`;
        }, 50);
      } else {
        elem.style.opacity = 1;
        elem.style.filter = "alpha(opacity=1)";
      }
    },
    fadeOut(elem, ms) {
      if (!elem) return;

      if (ms) {
        let opacity = 1;
        const timer = setInterval(function() {
          opacity -= 50 / ms;
          if (opacity <= 0) {
            clearInterval(timer);
            opacity = 0;
            elem.style.display = "none";
            elem.style.visibility = "hidden";
          }
          elem.style.opacity = opacity;
          elem.style.filter = `alpha(opacity=${opacity * 100})`;
        }, 50);
      } else {
        elem.style.opacity = 0;
        elem.style.filter = "alpha(opacity=0)";
        elem.style.display = "none";
        elem.style.visibility = "hidden";
      }
    },
    randomColorGen() {
      let r = Math.floor(Math.random() * 255) + 1;
      let g = Math.floor(Math.random() * 255) + 1;
      let b = Math.floor(Math.random() * 255) + 1;
      let color = `${r}, ${g}, ${b}`;
      return color;
    },
    bubble(x, y, dx, dy, radius, colors) {
      this.x = x;
      this.y = y;
      this.dx = dx;
      this.dy = dy;
      this.origRadius = radius;
      this.radius = radius;
      this.minRadius = radius;
      this.colors = colors;

      draw = function() {
        this.ctx.beginPath();
        // x, y, radius, Math.PI / 180 * startAngle, Math.PI / 180 * endAngle, anticlockwise
        this.ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false);
        this.ctx.fillStyle = colors;
        this.ctx.fill();
      };

      (this.update = function() {
        // boundry detection
        if (this.x + this.radius > innerWidth || this.x - this.radius < 0) {
          this.dx = -this.dx; // move left
        }
        if (this.y + this.radius > innerHeight || this.y - this.radius < 0) {
          this.dy = -this.dy; // move up
        }
        this.x += this.dx; // move right
        this.y += this.dy; // move down

        /*
        interactivity:
        positive numbers check for bubbles that are left or above the mouse.
        negative numbers check for bubbles that are right or below the mouse
        */
        if (
          this.mouse.x - this.x < this.radius &&
          this.mouse.x - this.x > -this.radius &&
          this.mouse.y - this.y < this.radius &&
          this.mouse.y - this.y > -this.radius &&
          this.radius != 0
        ) {
          this.radius += this.bubbleExpansionRate; // enlarge bubble
          if (this.radius > this.maxExpansion) {
            this.destroy(this.origRadius);
          }
        } else if (this.radius > this.minRadius && this.radius != 0) {
          this.radius -= this.bubbleExpansionRate; // shrink bubble
          this.mouse.x = 0;
          this.mouse.y = 0;
        }

        // redraw each time bubble.update() is called
        this.draw();
      }),
        (this.destroy = function(origRadius) {
          this.playSound(origRadius);
          this.radius = 0;
          this.x = -10;
          this.y = -10;
          this.dx = 0;
          this.dy = 0;
          this.bubblesPoppedPerLevel += 1;
          this.bubblesPoppedTotal += 1;

          // check if the last bubble was popped
          this.checkProgress();
        });
    },
    bubbleMultiplier() {
      this.bubblesQueue = [];

      // on resize make a prorated amount of bubbles each level based on current progress
      let bubbleNums = this.bubbleQnty - this.bubblesPoppedPerLevel;

      // random bubbles
      for (let i = 0; i < bubbleNums; i++) {
        // random bubble size
        let radius = Math.floor(Math.random() * this.maxRadius) + 25;
        let x = Math.random() * (innerWidth - radius * 2) + radius;
        let y = Math.random() * (innerHeight - radius * 2) + radius;
        let dx = (Math.random() - 0.5) * this.speed;
        let dy = (Math.random() - 0.5) * this.speed;

        // random opacity for each bubble
        let a = Math.random() * (1 - 0.15) + 0.15;
        let colors = `rgba(${this.randomColorGen()} , ${a})`;

        const args = [x, y, dx, dy, radius, colors];

        // instantiate new bubbles and store in array
        this.bubblesQueue.push(this.bubble(...args));
      }
    },
    animate() {
      // animate bubble
      requestAnimationFrame(this.animate); // recursive callback

      // clear last position
      this.ctx = this.$refs.myCanvas
        ? this.$refs.myCanvas.getContext("2d")
        : null;
      this.ctx.clearRect(0, 0, innerWidth, innerHeight);

      // call bubble functions
      this.bubblesQueue.forEach((item, i) => {
        this.bubblesQueue[i].update();
      });
    },
    setMouseCoords(event) {
      this.mouse.x = event.x;
      this.mouse.y = event.y;
    }, //GamePlay
    start() {
      this.level = 1;
      // track mouse
      this.canvasWrapper.addEventListener(
        "mousemove",
        function(event) {
          // get mouse position
          event.preventDefault();
          event.stopPropagation();
          this.setMouseCoords(event);
        },
        false
      );

      this.canvasWrapper.addEventListener(
        "click",
        function(event) {
          // get mouse position
          event.preventDefault();
          event.stopPropagation();
          this.setMouseCoords(event);
        },
        false
      );

      this.speed = 3; // start off for level 1
      this.bubbleQnty = 8; // start off for level 1
      this.canvas.classList.add("active"); // increase opacity of canvas
      this.fadeOut(this.introElm, 200); // fade out intro
      this.bubbleMultiplier(); // make bubbles
      this.stopwatch.startTimer();
    },
    startTimer() {
      this.startTime = new Date();
    }, //StopWatch
    stopTimer() {
      this.endTime = new Date();
    },
    resetTimer() {
      this.startTime = null;
      this.endTime = null;
      this.duration = 0;
    },
    showDuration() {
      let time = (this.endTime.getTime() - this.startTime.getTime()) / 1000;
      const secs = parseInt(time, 10);
      let minutes = Math.floor(secs / 60);
      let seconds = secs - minutes * 60;
      let formatTime;
      if (minutes > 0) {
        let onesPlace = seconds < 10 ? "0" : "";
        formatTime = `${minutes}:${onesPlace}${seconds}!`;
      } else {
        formatTime = `${seconds} seconds!`;
      }
      return formatTime;
    },
    checkProgress() {
      if (this.bubblesPoppedPerLevel === this.bubbleQnty) {
        this.stopwatch.stopTimer();
        this.level += 1; // increment level
        this.canvas.classList.remove("active"); // reduce canvas opacity
        this.showHideLevelMsg();
      }
    },
    showHideLevelMsg() {
      this.progressElm.innerHTML = `${
        this.bubblesPoppedPerLevel
      } bubbles popped in ${this.stopwatch.showDuration()}`;
      this.bubblesPoppedPerLevel = 0; // reset counter
      this.stopwatch.resetTimer();

      // random RGB values
      let color = `color:rgba(${this.randomColorGen()} , 1)`;
      // this.levelMsg.setAttribute("style", color);
      //this.levelMsg.innerHTML = `Level ${this.level}`;

      // popped bubble count and elapsed time message
      const delayShowProgress = setTimeout(() => {
        clearTimeout(delayShowProgress);

        // fade in progress message
        this.fadeIn(this.progressElm, 800);

        const delayHideProgress = setTimeout(() => {
          clearTimeout(delayHideProgress);

          // fade out progress message while fading in level message
          this.fadeOut(this.progressElm, 600);
        }, 4800);
      }, 200);

      // level number indicator
      const delayShowLevel = setTimeout(() => {
        clearTimeout(delayShowLevel);

        // fade in level message
        this.fadeIn(this.levelsElm, 800);

        const delayHideLevel = setTimeout(() => {
          clearTimeout(delayHideLevel);

          // fade out level message and start next level
          this.fadeOut(this.levelsElm, 600);
          this.nextLevel();
        }, 3000);
      }, 2000);
    },
    nextLevel() {
      this.speed += 0.5; // increase speed each level
      //this.bubbleExpansionRate += 0.5;
      this.bubbleQnty += 5; // increment bubbles by num for each level
      if (this.maxRadius + 15 < this.maxExpansion) {
        this.maxExpansion -= 5; // reduce expansion size as game speeds up
      }

      const delayShowNext = setTimeout(() => {
        clearTimeout(delayShowNext);

        this.bubbleMultiplier(); // make bubbles
        this.canvas.classList.add("active"); // increase canvas opacity
        this.stopwatch.startTimer();
      }, 800);
    },
    playSound(origRadius) {
      this.sound = null;
      if (origRadius <= 34) {
        this.sound = this.loadSounds().high;
      } else if (origRadius > 34 && origRadius <= 42) {
        this.sound = this.loadSounds().med;
      } else {
        this.sound = this.loadSounds().low;
      }
      this.sound.play();
    },
    bind() {
      // make new bubbles on resize
      /* window.addEventListener("resize", function() {
        this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerHeight;
        if (this.bubblesPoppedPerLevel != 0 || this.level === 0) {
         this.bubbleMultiplier();
        }
      });*/
    }
  },
  data() {
    return {
      canvas: this.$refs.myCanvas,
      progressElm: document.querySelector(".progress"),
      introElm: document.querySelector(".intro"),
      levelsElm: document.querySelector(".levels"),
      // levelMsg: document.querySelector(".levels").firstElementChild,
      startBtn: this.$refs.startBtn,
      //canvas: document.getElementById("canvas"),
      canvasWrapper: document.getElementById("canvas-wrapper"),
      ctx: this.$refs.myCanvas ? this.$refs.myCanvas.getContext("2d") : null,
      mouse: {
        x: undefined,
        y: undefined
      },
      level: 0,
      bubbleQnty: 50, // 50 to start as example
      bubblesPoppedPerLevel: 0,
      bubblesPoppedTotal: 0,
      bubbleExpansionRate: 5,
      speed: 8,
      maxRadius: 45,
      maxExpansion: 150,
      bubblesQueue: [],
      stopwatch: {
        startTime: null,
        endTime: null,
        duration: 0
      }
    };
  }
};
</script>

<style lang="scss" scoped>
html,
body {
  width: 100%;
  height: 100%;
}

body {
  margin: 0;
  font-family: "Sniglet", cursive;
  color: hotpink;
  overflow: hidden;
}

header {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -40%);
  z-index: 2;
  text-align: center;
  display: flex;
  flex-direction: column;
}

h1 {
  font-weight: 600;
  margin: 50px 0;
  font-size: 4rem;
  color: hotpink;
  text-shadow: -1px -1px 0 #c546c5, 1px -1px 0 #c546c5, -1px 1px 0 #c546c5,
    1px 1px 0 #c546c5, 0 0 100px rgba(255, 255, 255, 1);
}

.intro {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -40%);
  z-index: 2;
  text-align: center;
}

.start {
  background: hotpink;
  border: none;
  padding: 6px 50px;
  border-radius: 60px;
  font-family: "Sniglet", cursive;
  font-size: 1.5rem;
  color: #fff;
  cursor: pointer;
  text-shadow: 0 0 5px #c546c5;
  border: 2px solid rgba(197, 70, 197, 0.3);
  box-shadow: 0 0 100px rgba(255, 255, 255, 0.3);
  will-change: transform;
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.16);
    transition: transform 0.2s;
  }
}

.progress {
  position: absolute;
  left: 50%;
  top: 35%;
  width: 100%;
  transform: translate(-50%, -35%);
  z-index: 2;
  padding: 0 30px;
  line-height: 1.35;
  text-align: center;
  font-size: 1.75rem;
  color: purple;
  opacity: 0;
  transition: opacity 0.5s;
  transition: transform 0.2s;
  &.active {
    opacity: 1;
    transition: opacity 0.15s;
  }
}

.levels {
  position: absolute;
  left: 50%;
  top: 47%;
  width: 100%;
  transform: translate(-50%, -47%);
  padding: 0 30px;
  text-align: center;
  display: none;
  @media only screen and (max-width: 375px) {
    top: 52%;
    transform: translate(-50%, -52%);
  }
}

#canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  opacity: 0.5;
  transition: opacity 0.5s;
  &.active {
    opacity: 1;
    transition: opacity 1s;
  }
}
</style>
